export default {
  student: 'student',
  preceptor: 'preceptor',
};
